var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGrid = function SvgGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6.4,
    height: 6.4,
    x: 10.6,
    y: 10.6,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 1,
    vectorEffect: "non-scaling-stroke"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6.4,
    height: 6.4,
    x: 1,
    y: 1,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 1,
    vectorEffect: "non-scaling-stroke"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 6.4,
    height: 6.4,
    x: 10.4,
    y: 1,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 1,
    vectorEffect: "non-scaling-stroke"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 6.4,
    height: 6.4,
    x: 1,
    y: 10.6,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 1,
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgGrid;